<template>
    <div class="appPage" ref="indexRoll">
        <!-- 头图 -->
        <van-swipe class="kwaiBar" :autoplay="3000">
            <van-swipe-item v-for="(item, index) in bannerList" :key="'bar_' + index">
                <img :src="item.photo" v-if="item.address == '' || item.address == null" />
                <a :href="item.address" target="_blank" v-else style="color: #4a2e0f">
                    <img :src="item.photo" />
                </a>
            </van-swipe-item>
        </van-swipe>
        <!-- 上下滚动新闻 -->
        <div class="kwaiRoll">
            <van-swipe class="kwaiRoll1" :autoplay="2800" :show-indicators="false" vertical>
                <van-swipe-item v-for="(item, index) in rollTips" :key="'roll' + index" @click="jumpOut(item.address)">
                    <a :href="item.address" target="_blank">
                        {{ item.title }}
                    </a>
                </van-swipe-item>
            </van-swipe>
        </div>

        <!-- 大会直播入口 -->
        <img :src="ossLink + 'img1/titleLive.png?v=1'" class="titleLive" />
        <!-- <div class="liveBox" v-if="showLive.show == 1">
            <div class="liveTips">
                <span>己经有</span>
                <strong>{{ liveNum }}</strong>
                <span>人次查看了直播</span>
            </div>
            <div class="liveBtn" @click="jumpOut(showLive.address)"></div>
        </div> -->
        <a class="albumPic" :href="showPhoto.address" target="_blank">
            <img :src="showPhoto.photo" v-if="showPhoto.photo != '' && showPhoto.photo != null" />
        </a>
        <div class="albumBox">
            <div class="albumTips" v-if="showPhoto.show == 1">
                <span>己经有</span>
                <strong>{{ albumNum }}</strong>
                <span>人次查看了相册</span>
            </div>
            <a :href="showPhoto.address" class="albumBtn" target="_blank"></a>
        </div>
        <!-- 精彩视频 -->
        <img :src="ossLink + 'img1/titleVideo.png'" class="titleVideo" v-if="showVideo.show == 1" />
        <div class="videoBox" v-if="showVideo.show == 1">
            <img :src="ossLink + 'img1/icon.png'" class="icon" />
            <div class="videoList" v-for="(item, index) in listVideo" v-if="index < 1" :key="'vid_' + index"
                @click="jumpOut2(index)">
                <img :src="item.photo" v-if="item.photo" />
                <div class="img" v-if="!item.photo"></div>
                <p v-if="item.title != '' && item.title != null">{{ item.title }}</p>
            </div>
            <div class="videoBtn" @click="jumpTo('/Video')"></div>
        </div>
        <!-- 四强介绍 -->
        <img :src="ossLink + 'img1/titleTeam.png'" class="titleVideo" v-if="team != ''" />
        <div class="teamBox" v-if="team != ''">
            <p class="team1" @click='teamPath(0)'>
                <img src="../assets/ball.png" alt="">
                {{ team[0].title }}
            </p>
            <p class="team2" @click='teamPath(1)'>
                <img src="../assets/ball.png" alt="">
                {{ team[1].title }}
            </p>
            <p class="team3" @click='teamPath(2)'>
                <img src="../assets/ball.png" alt="">
                {{ team[2].title }}
            </p>
            <p class="team4" @click='teamPath(3)'>
                <img src="../assets/ball.png" alt="">
                {{ team[3].title }}
            </p>
        </div>
        <!-- 相关文章 -->
        <img :src="ossLink + 'img1/titleArticles.png'" class="titleArticles" v-if="showNews.show == 1" />
        <div class="articlesBox" v-if="showNews.show == 1">
            <a v-for="(item, index) in listArticles" v-if="index < 4" :key="'art_' + index" class="articlesList"
                :href="item.address" target="_blank">
                <img :src="item.photo" v-if="item.photo" />
                <div class="img" v-if="!item.photo"></div>
                <!-- <p class="h3">{{ item.title }}</p> -->
                <p>{{ item.subtitle }}</p>
            </a>
            <div class="articlesBtn" @click="jumpTo('/Articles')"></div>
        </div>
        <nice :shareNum="shareNum" />
    </div>
</template>

<script>
import nice from '@/plugins/nice.vue';
// import { dataForm } from '@/utils/toolSet';
export default {
    name: 'Index',
    components: {
        nice
    },
    data () {
        return {
            title: '',
            ossLink: 'https://oss.eventnet.cn/H5/kwaiPlay/',
            bannerList: [],
            rollTips: [],
            listArticles: [],
            listVideo: [],
            liveNum: '00000',
            albumNum: '',
            shareNum: '',
            showLive: {},
            showPhoto: {},
            showVideo: {},
            showNews: {},
            team: []
        };
    },
    created () {
        const THAT = this;
        THAT.albumSet();
        THAT.axios.get('https://oss.eventnet.cn/H5/kwaiPlay/img1/request1.json?v=' + new Date().getTime()).then(res => {
            THAT.bannerList = res.banner;
            THAT.rollTips = res.tips;
            THAT.listArticles = res.news;
            THAT.listVideo = res.video;
            THAT.team = res.team ? res.team : [];
            for (let i = 0; i < res.section.length; i++) {
                if (res.section[i].type == 'photo') {
                    THAT.showPhoto = res.section[i];
                } else if (res.section[i].type == 'video') {
                    THAT.showVideo = res.section[i];
                } else if (res.section[i].type == 'news') {
                    THAT.showNews = res.section[i];
                }
            }
        }).catch(err => {
            console.log(err);
        });
    },
    mounted () {
        // this.touchEnd();
        const THAT = this;
        THAT.$refs.indexRoll.scrollTop = 0;
        /* setInterval(() => {
            THAT.axios.get('https://rally.event1.cn/api/tgc/getnum')
                .then(res => {
                    THAT.albumNum = res.data.flowTotal;
                }).catch(err => err)
        }, 10000) */
    },
    methods: {
        teamPath (index) {
            const THAT = this;
            THAT.$router.push('/team?index=' + index).catch(err => err);
        },
        jumpOut2 (uid) {
            const THAT = this;
            if (THAT.listVideo[uid].address) {
                localStorage.setItem('video-kwai', JSON.stringify(THAT.listVideo[uid]));
                THAT.$router.push('/Play').catch(err => err);
            }
        },
        jumpTo (to) {
            const THAT = this;
            THAT.$router.push(to).catch(err => err);
        },
        jumpOut (url) {
            if (url == '' || url == null) { } else {
                window.location.href = url;
            }
        },
        openArticles (url) {
            const THAT = this;
        },
        albumSet () {
            const THAT = this;
            /* THAT.axios.get('https://rally.event1.cn/api/tgc/getnum')
                .then(res => {
                    THAT.albumNum = res.data.flowTotal;
                }).catch(err => err) */
            THAT.axios.post('Photo/albumSet').then(res => {
                if (res.code == 200) {
                    THAT.liveNum = res.siteInfo.LiveNum;
                    THAT.albumNum = res.siteInfo.PhotoNum;
                    THAT.shareNum = res.siteInfo.ShareNum;
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.appPage {
    // height: 3520px;
    padding-bottom: 150px;
    background: url('../assets/bg.jpg') no-repeat;
    background-size: 100%;
    background-position: center bottom;
    padding-top: 50px;

    .titleLive,
    .titleVideo,
    .titleArticles {
        width: 353px;
        height: 106px;
        margin: 0 auto 20px;
    }

}

.kwaiBar {
    width: 691px !important;
    height: 387px !important;
    overflow: hidden;
    border-radius: 15px;
    margin: auto;

    .van-swipe-item {
        width: 691px !important;
        height: 387px !important;

        a {
            display: block;
            width: 100%;
            height: 387px;
        }

        img {
            width: 100%;
            height: 387px;
        }
    }
}

@font-face {
    font-family: font;
    src: url(../assets/font.ttf);
}

.kwaiRoll {
    position: relative;
    width: 693px !important;
    height: 90px !important;
    background: url(../assets/kwaiRoll.png) no-repeat;
    background-size: 100% 100%;
    border-radius: 5px;
    // overflow: hidden;
    padding-left: 70px;
    margin: 20px auto 59px;
    color: #fff;

    .kwaiRoll1 {
        height: 70px !important;
        font-family: font;

        .van-swipe-item {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;

            a {
                display: block;
                font-size: 22px;
                display: flex;
                align-items: center;
                height: 70px !important;
                line-height: 30px;
                padding-top: 5px;
                padding-right: 10px;
                color: #fff;
            }
        }
    }

    &::before {
        content: '';
        position: absolute;
        top: 10px;
        left: 0;
        z-index: 3;
        display: block;
        width: 55px;
        height: 47px;
        background: url('https://oss.eventnet.cn/H5/kwaiPlay/img/iconTips.gif') center no-repeat;
        background-size: 35px 31px;
    }


}

.liveBox,
.albumBox {
    width: 680px;
    height: 110px;
    background: url('../assets/bgLive.png') no-repeat;
    background-size: 100% 100%;
    margin: 0 auto 57px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .liveTips,
    .albumTips {
        font-family: font;
        height: 40px;
        border-radius: 20px;
        margin-bottom: 5px;
        padding: 1px 35px 1px;
        font-size: 22px;
        line-height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;

        strong {
            color: #fff;
            font-size: 26px;
            margin: 0 5px;
        }
    }

    .liveBtn {
        width: 191px;
        height: 55px;
        background: url('https://oss.eventnet.cn/H5/kwaiPlay/img/btn1.png') no-repeat;
        background-size: 100% 100%;
    }

    .albumBtn {
        width: 178px;
        height: 49px;
        background: url('../assets/btn2.png') no-repeat;
        background-size: 100% 100%;
    }
}

.albumPic {
    display: block;
    width: 684px;
    height: 397px;
    overflow: hidden;
    margin: 0 auto 18px;

    img {
        width: 684px;
        height: 397px;
    }
}

.videoBox {
    position: relative;
    z-index: 2;
    width: 692px;
    height: 457px;
    background-color: #2945d4;
    border-radius: 10px;
    margin: 0 auto 57px;
    padding: 12px 0 30px;
    overflow: hidden;

    .icon {
        width: 221px;
        height: 221px;
        position: absolute;
        right: -30px;
        bottom: -75px;
    }

    .videoList {
        position: relative;
        padding-bottom: 15px;
        width: 671px;
        margin: 0 auto;

        &::before {
            content: '';
            position: absolute;
            top: 145px;
            left: 50%;
            z-index: 5;
            display: block;
            margin-left: -40px;
            width: 80px;
            height: 80px;
            background: #fff url('https://oss.eventnet.cn/H5/kwaiPlay/img/24gf-playCircle.png') no-repeat;
            background-size: 100% 100%;
            border-radius: 50%;
            opacity: 0.5;
            animation: breathing 5s linear infinite;
            transform: scale(0.8);
            pointer-events: none;
        }

        img {
            width: 671px;
            height: 365px;
            border-radius: 5px;
            pointer-events: all;
            background: #fc591b;
            margin: 0 auto;
        }

        .img {
            width: 671px;
            height: 365px;
            border-radius: 5px;
            pointer-events: all;
            background: #fc591b;
            margin: 0 auto;
            border: none;
        }

        p {
            font-size: 24px;
            text-align: center;
            margin: 15px;
        }
    }

    .videoBtn {
        display: block;
        width: 254px;
        height: 55px;
        background: url('../assets/btn3.png') no-repeat;
        background-size: 100% 100%;
        margin: auto;
    }
}

.teamBox {
    width: 687px;
    height: 280px;
    margin: 0 auto;
    background: url(../assets/team_bg.png) no-repeat;
    background-size: 100%;
    position: relative;

    p {
        display: flex;
        align-items: center;
        font-size: 20px;
        color: #fff;
        border: 1px solid #fff;
        background: rgba(255, 255, 255, .5);
        position: absolute;
        padding: 5px 10px;
        line-height: 1;
        width: 220px;
        word-break: keep-all;

        &.team2 {
            left: 70px;
            top: 75px;
        }

        &.team1 {
            right: 70px;
            top: 75px;
        }

        &.team3 {
            left: 70px;
            top: 140px;
        }

        &.team4 {
            right: 70px;
            top: 140px;
        }
    }

    img {
        width: 25px;
        height: 25px;
        margin-right: 7px;
    }
}

.articlesBox {
    position: relative;
    z-index: 2;
    width: 684px;
    background-color: #fc591b;
    border-radius: 10px;
    margin: 0 auto 0;
    padding: 60px 17px 25px;
    font-family: font;

    .articlesList {
        position: relative;
        width: 100%;
        height: 130px;
        padding-left: 245px;
        margin-bottom: 30px;
        display: block;
        color: #fff;

        img {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 231px;
            height: 130px;
            border-radius: 8px;
        }

        .img {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 231px;
            height: 160px;
            border-radius: 8px;
            background: #2945d4;
        }

        .h3 {
            font-size: 28px;
            line-height: 40px;
            margin-bottom: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        p {
            font-size: 24px;
            line-height: 32px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }
    }

    .articlesBtn {
        width: 254px;
        height: 55px;
        background: url('../assets/btn4.png') no-repeat;
        background-size: 100% 100%;
        margin: 40px auto 0;
    }
}

.van-swipe__indicator--active {
    width: 8px !important;
    height: 8px !important;
}
</style>